export default __webpack_public_path__ + "static/media/4-1_ellipsis.ebefc434.svg";